{
    "quote": "Angebot",
    "order": "Auftrag",
    "order_info__1_title": "Kunde",
    "order_info__1_item_title__customer_id": "Kunden-Nr.",
    "order_info__1_item_title__customer": "Kunde",
    "order_info__1_item_title__sales_manager": "Vertreter",
    "order_info__1_item_title__customer_contact": "Kontaktperson",
    "order_info__1_item_title__po_number": "Kommission",
    "quote_info__2_title": "Angebotskonfiguration",
    "order_info__2_title": "Auftragskonfiguration",
    "order_info__2_item_title__created_date": "Erstellt am",
    "order_info__2_item_title__order_type": "Auftragsart",
    "order_info__2_item_title__collector": "Erfasser",
    "header_info_title": "Kopfdaten",
    "header_info__sum_line_items": "Summe Positionen",
    "header_info__sum_incl_surcharges": "Summe inkl. Zuschlägen",
    "header_info__gross_margin": "DB",
    "header_info__gross_margin_percent": "DB %",
    "header_info__total_line": "Anzahl Positionen",
    "order_info__3_title": "Logistik",
    "order_info__3_item_title__warehouse": "Lager",
    "order_info__3_item_title__shipping_method": "Versandart",
    "order_info__3_item_title__service_provider": "Dienstleister",
    "order_info__3_item_title__delivery_address": "Lieferadresse",
    "order_info__3_item_title__billing_address": "Rechnungsadresse",
    "order_info__3_item_title__order_desired_delivery_date": "Gewünschtes Datum",
    "order_info__3_item_title__quote_due_date": "Gültig bis",
    "tabs__details": "Details",
    "tabs__attachments": "PDF Belege",
    "attachments__column_document": "Dokument",
    "attachments__column_date_added": "Erstellt am",
    "attachments__column_type": "Dokumententyp",
    "attachments__action_preview": "Vorschau",
    "attachments__action_download": "Herunterladen",
    "attachments__error_preview": "Dokument konnte nicht geöffnet werden",
    "attachments__error_download": "Dokument konnte nicht heruntergeladen werden"
}
